import { Link } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";

import { useCustomerContext } from "../../../../../Context/CustomerContext";
import TimeRangeSelector, { TimeRange } from "../../ClusterDetail/Components/TimeRangeSelector";

const availableTimeRanges: TimeRange[] = [TimeRange.T_3D, TimeRange.T_7D, TimeRange.T_14D, TimeRange.T_30D];

interface Fsk8sHeaderProps {
  onChangeTimeRange: (timeRange: TimeRange) => void;
  timeRange: TimeRange;
}

const Fsk8sHeader = ({ timeRange, onChangeTimeRange }: Fsk8sHeaderProps) => {
  const { customer } = useCustomerContext();

  return (
    <Box justifyContent="flex-end" display="flex" alignItems="center">
      <Stack direction="row" spacing={1}>
        <Button component={Link} to={`/customers/${customer.id}/integrate/assets/kubernetes`} variant="outlined">
          Manage clusters
        </Button>
        <TimeRangeSelector
          value={timeRange}
          onChange={onChangeTimeRange}
          filterAvailableOptions={(t) => availableTimeRanges.includes(t)}
        />
      </Stack>
    </Box>
  );
};

export default Fsk8sHeader;
